toQueryResult